import StateInterface from "../state-interface";
export const home_location: StateInterface["home_location"] = {
  name: "Bangalore",
  location: [77.5946, 12.9716],
};
